import { IconButton } from '@material-ui/core'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'

import { widthXS } from '../theme'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    margin: theme.layout.gridTypographyTextMargin,
    paddingLeft: 0,
    paddingRight: 0,
  },
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    backgroundColor: '#F9F8E5',
    border: '1px solid #ECE9B2',
  },
  customizedButton: {
    color: 'gray',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  FAQ: {
    color: theme.palette.primary.paragraphFont,
    fontSize: '1.5rem',
    [theme.breakpoints.down(widthXS)]: {
      fontSize: '1rem',
      paddingRight: '0.6rem',
      paddingLeft: '0.6rem',
    },
    fontWeight: 600,
    fontFamily: theme.palette.primary.fontW1G,
    letterSpacing: 0.24,
    paddingLeft: '1.2rem',
    paddingRight: '1.2rem',
    margin: '0 0 1.2rem 0',
  },
  paragraphText: {
    color: theme.palette.primary.paragraphFont,
    fontSize: '1rem',
    [theme.breakpoints.down(widthXS)]: {
      fontSize: '0.8rem',
      paddingRight: '0.6rem',
      paddingLeft: '0.6rem',
    },
    fontWeight: 600,
    fontFamily: theme.palette.primary.fontW1G,
    letterSpacing: 0.24,
    paddingLeft: '1.2rem',
    paddingRight: '1.2rem',
    margin: '0 0 0.5rem 0',
  },
  defaultText: {
    fontSize: '1rem',
    [theme.breakpoints.down(widthXS)]: {
      fontSize: '0.8rem',
      paddingRight: '0.6rem',
      paddingLeft: '0.6rem',
    },
    fontFamily: theme.palette.primary.fontW1G,
    letterSpacing: 0.24,
    paddingLeft: '1.2rem',
    paddingRight: '1.2rem',
    margin: '0 0 1rem 0',
  },
}))

function InfoBox({ t }) {
  const classes = useStyles()
  const [open, setOpen] = useState(true)

  const handleClose = () => {
    setOpen(false)
  }

  return (
    open && (
      <Container className={classes.root}>
        <Grid container direction="column" justify="flex-start" className={classes.container}>
          <Grid item xs={12} xl={12} sm={12} className={classes.customizedButton}>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
          <Grid item xs={12} xl={12} sm={12}>
            <Typography className={classes.FAQ}>{t('loginPg.infoBox.faq')}</Typography>
            <Typography className={classes.paragraphText}>{t('loginPg.infoBox.title')}</Typography>
            <Typography className={classes.defaultText}>{t('loginPg.infoBox.titleText')}</Typography>
            <Typography className={classes.paragraphText}>{t('loginPg.infoBox.subTitle')}</Typography>
            <Typography className={classes.defaultText}>{t('loginPg.infoBox.subTitleText')}</Typography>
          </Grid>
        </Grid>
      </Container>
    )
  )
}

export default withTranslation()(InfoBox)
